import React from 'react';
import { Typography, Grid, makeStyles, Button } from '@material-ui/core'
import { useHistory } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { ApplicationState } from '../../reducers';
import { User, UserRole } from '../../domain/domain';

const useStyles = makeStyles(_ => ({
    root: {
        marginTop: 100,
    },
    nav: {
        marginTop: 50
    },
    button: {
        textTransform: 'none',
        color: '#186ea8',
        fontSize: 24,
        fontWeight: 300,
        '&:hover': {
            backgroundColor: 'inherit',
            color: '#2e9e9e'
        }
    }
}));

const Landing: React.FC = () => {
    const classes = useStyles();
    const history = useHistory();

    let currentUser: User | undefined = useSelector((app: ApplicationState) => app.user.currentUser);

    return (
        <Grid container direction='column' alignContent='center' spacing={5} alignItems='center' className={classes.root}>
            <Grid item>
                <Typography variant='h1'>Welcome to XDOME</Typography>
            </Grid>
            <Grid item className={classes.nav}>
                <Grid container direction='column' alignItems='center'>
                    <Grid item>
                        <Button size="large" className={classes.button} onClick={() => { history.push("/component") }}>Provision Management</Button>
                    </Grid>
                    <Grid item>
                        <Button disabled={currentUser?.userRole === UserRole.NON_PUBLICATIONS_TEAM} size="large" className={classes.button} onClick={() => { history.push("/red-book") }}>Red Book Page to Print/View/Merge a Bill</Button>
                    </Grid>
                    <Grid item>
                        <Button disabled={currentUser?.userRole === UserRole.NON_PUBLICATIONS_TEAM} size="large" className={classes.button} onClick={() => { history.push("/status") }}>Title Status</Button>
                    </Grid>
                    <Grid item>
                        <Button disabled={true} size="large" className={classes.button} onClick={() => { history.push("/scheduled") }}>Statute Components scheduled for a future repeal</Button>
                    </Grid>
                </Grid>
            </Grid>
        </Grid>
    )
}

export default Landing;
